import { Loader2 } from 'lucide-react';

import CtaLink from '@/components/CtaLink';
import { cn } from '@/lib/utils';

import { CTA } from './copy';

/**
 * El «Começar o meu plano». Cada sitio de la landing lo monta con SU id
 * (`landing.oferta-pt.comprar-*`), que mide el click y viaja al checkout para
 * llevarse el alta: así se sabe cuál de los cinco vende.
 *
 * `para`: el negocio, en una segunda línea («para Café da Praça»). Solo en la
 * landing personalizada (V6), en el bloque del precio y la tarjeta de ordenador.
 *
 * @param {{ cta: string, comecar: (id: string) => void, cargando: string|null,
 *           className?: string, para?: string, children?: React.ReactNode }} props
 */
export default function BotaoComecar({ cta, comecar, cargando, className, para, children }) {
  return (
    <CtaLink
      as="button"
      type="button"
      cta={cta}
      onClick={() => comecar(cta)}
      disabled={!!cargando}
      className={cn(
        'inline-flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-[#feae2c] px-5 text-[17px] font-bold text-[#1d1d1f] shadow-[0_8px_24px_rgba(254,174,44,0.35)] transition-colors hover:bg-[#f59e0b] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#9a5700] disabled:cursor-wait disabled:opacity-80',
        className,
      )}
    >
      {cargando === cta && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
      {para ? (
        <span className="flex flex-col items-center leading-tight">
          <span>{children || CTA}</span>
          <span className="text-xs font-semibold text-[#6b3d00]">para {para}</span>
        </span>
      ) : (children || CTA)}
    </CtaLink>
  );
}
